import { axiosObject } from "../accessServiceConfig";

export default function adminLogin(form: any) {
  let payload = {
    email: form.value.email,
    password: form.value.password,
  };

  return new Promise((resolve, reject) => {
    let uri = "/admin/login";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response?.status === 422) {
          if (errors.response.data.message === "AttributeNotVerified") {
            reject(errors.response.data);
          } else {
            form.setErrors({ password: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}
